import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { Box, Button, Stack, Typography } from "@mui/material";

import useData from "../../hooks/useData";
import useLocalization from "../../hooks/useLocalization";
import usePage from "../../hooks/usePage";

import Page from "./Page";
import Card from "../layout/Card";
import FileUpload from "../elements/FileUpload";

const Imports = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { getFromServer } = useData();
  const { getTitle } = useLocalization();
  const { showMessage } = usePage();

  const [data, setData] = useState(null);
  const [entityName, setEntityName] = useState(null);
  const [entityId, setEntityId] = useState(null);
  const [clientId, setClientId] = useState(null);

  const [importType, setImportType] = useState(null);

  const currentUserId = useSelector((state) => state.authentication.userId);
  const email = useSelector((state) => state.authentication.email);

  useEffect(() => {
    setEntityId(location.state.entityId);
    setEntityName(location.state.entityName);
    setClientId(location.state.clientId);
  }, []);

  useEffect(() => {
    getData();
  }, [entityId]);

  const getData = async () => {
    if (!entityId) {
      setData(null);
      return;
    }

    const results = await getFromServer({ entityName, id: entityId });
    if (results) {
      setData(results);
    } else {
      setData(null);
    }
  };

  const handleToolbarClick = async (name) => {
    switch (name) {
      case "project":
        navigate("/project", { state: { projectId: entityId, clientId } });
        break;
    }
  };

  const handleImportSelection = (type) => {
    setImportType(type);
  };

  const handleUploaded = () => {
    showMessage("You will receive an email on completion.");
  };

  if (!data) return null;

  return (
    <>
      <Page
        pageName={getTitle("imports")}
        entityName={data.name}
        includeToolbar
        items={[{ name: "project", iconName: "Lan" }]}
        onToolItemClick={handleToolbarClick}
      >
        <Box
          display="flex"
          gap={1}
        >
          <Card
            title={getTitle("Imports")}
            sx={{ width: "300px" }}
          >
            <Stack>
              {entityName === "Project" &&
              data.syndicationId !== null ? null : (
                <Box>
                  <Button
                    size="small"
                    onClick={() => handleImportSelection("locations")}
                  >
                    Locations
                  </Button>
                </Box>
              )}
              <Box>
                <Button
                  size="small"
                  onClick={() => handleImportSelection("schedule")}
                >
                  Schedule
                </Button>
              </Box>
              <Box>
                <Button
                  size="small"
                  onClick={() => handleImportSelection("listings")}
                >
                  Listings
                </Button>
              </Box>
            </Stack>
          </Card>

          {importType && (
            <Card
              title={getTitle(`import_${importType}`)}
              sx={{ width: "300px" }}
            >
              <Box padding="10px">
                <FileUpload
                  entityName={entityName}
                  entityId={entityId}
                  data={{
                    importType,
                    entityName: entityName,
                    entityId: entityId,
                    userId: currentUserId,
                    email: email,
                  }}
                  onUploaded={handleUploaded}
                />
              </Box>
            </Card>
          )}
        </Box>
      </Page>
    </>
  );
};

export default Imports;
